import React from "react";

interface SectionWithShapesProps {
  children: React.ReactNode;
  className?: string;
  id?: string;
}

/**
 * Wraps a section with decorative shapes (red circle top-left, yellow triangle top-right)
 * to match the design system used on Home and Initiatives. Treat sections as components
 * that carry their own shape decoration.
 */
const SectionWithShapes: React.FC<SectionWithShapesProps> = ({
  children,
  className = "",
  id,
}) => {
  return (
    <section
      id={id}
      className={`section-with-shapes ${className}`.trim()}
      style={{ position: "relative", overflow: "hidden" }}
    >
      <span
        className="section-shape section-shape--circle"
        aria-hidden
      />
      <span
        className="section-shape section-shape--triangle"
        aria-hidden
      />
      <div className="container" style={{ position: "relative", zIndex: 1 }}>
        {children}
      </div>
    </section>
  );
};

export default SectionWithShapes;
